module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki05_sp-a0c0910eed32e9414524c5f0068bf353.jpg";